<template>
	<div class="report">
		<div class="container">
			<div class="flex">
				<div class="title">工作报表</div>
				<el-button
					type="primary"
					class="export"
					@click="exportUser"
					:loading="exportUserLoading"
				>{{exportUserLoading?'正在处理...':'导出数据'}}</el-button>
				<div class="date_box">
					<el-date-picker
						v-model="pickerVal"
						type="daterange"
						value-format="yyyy-MM-dd"
						align="right"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:picker-options="pickerOptions"
					></el-date-picker>
				</div>
				<div class="clear"></div>
			</div>
			<div class="flex-box" v-loading="userHeadLoding">
				<div class="m-ValueBox">
					<div class="m-ValueBox-top">
						<div title="接入会话量">接入会话量</div>
						<div title="0">{{userHead.userAccessInfo.accessCount}}</div>
					</div>
					<div class="m-ValueBox-bottom">
						<div title="回复率 --">
							回复率
							<span v-if="userHead.userAccessInfo.replyReteCount==0">--</span>
							<span v-else>{{userHead.userAccessInfo.replyReteCount}}%</span>
						</div>
						<div title="转接量 0">
							转接量
							<span>{{userHead.userAccessInfo.transferCount}}</span>
						</div>
					</div>
				</div>
				<div class="m-ValueBox">
					<div class="m-ValueBox-top">
						<div title="接入会话量">总消息量</div>
						<div title="0">{{userHead.userMessageInfo.allMessageCount}}</div>
					</div>
					<div class="m-ValueBox-bottom">
						<div title="回复率 --">答问比：{{userHead.userMessageInfo.qOrARatio}}%</div>
						<div title="转接量 0">30s应答率：{{userHead.userMessageInfo.responseRate}}%</div>
					</div>
				</div>
				<div class="m-ValueBox">
					<div class="m-ValueBox-top">
						<div title="接入会话量">平均会话时长</div>
						<div title="0">{{convertMin(userHead.userConversationTime.aveContionSecond)}}</div>
					</div>
					<div class="m-ValueBox-bottom">
						<div title="回复率 --">平均首次响应时间：{{userHead.userConversationTime.firstAvgResponse}}s</div>
						<div title="转接量 0">
							平均响应时间：
							<span>{{userHead.userConversationTime.avgResponse}}s</span>
						</div>
					</div>
				</div>
				<div class="m-ValueBox">
					<div class="m-ValueBox-top">
						<div title="接入会话量">留言量</div>
						<div title="0">{{userHead.userLeavingaMessageHandle.leavingaMessageCount}}</div>
					</div>
					<div class="m-ValueBox-bottom">
						<div title="回复率">已处理：{{userHead.userLeavingaMessageHandle.processedCount}}</div>
						<div title="转接量 0">
							留言解决率:
							<span>{{userHead.userLeavingaMessageHandle.resolutionRate}}%</span>
						</div>
					</div>
				</div>
				<div class="m-ValueBox">
					<div class="m-ValueBox-top">
						<div title="接入会话量">满意度</div>
						<div title="0">{{userHead.userComment.satisfactionRate}}%</div>
					</div>
					<div class="m-ValueBox-bottom">
						<div title="回复率">参评率:{{userHead.userComment.participationRate}}%</div>
						<div title="转接量 0">
							一次性解决率:
							<span>{{userHead.userComment.oneTimeResolutionRate}}%</span>
						</div>
						<!-- <div title="转接量 0">
							用户解决率
							<span>{{userHead.userComment.satisfactionRate}}</span>
						</div>-->
					</div>
				</div>
			</div>
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">已接入会话量</span>
					</div>
				</div>
				<div id="main-1" style="width:100%;height:420px;" v-loading="userCenterAccessLoding"></div>
			</div>
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">消息量</span>
					</div>
				</div>
				<div id="main-2" style="width:100%;height:420px;" v-loading="userCenterMessageLoding"></div>
			</div>
			<div class="flex-box">
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">首次响应时间</span>
						</div>
					</div>
					<div class="main-3" style="height:300px;" v-loading="userResponseLoading">
						<div class="m-bar">
							<div class="m-bar-title">>1m</div>
							<div class="progress">
								<div class="p1" :style="{width:response.firstResponse.firstResponseGreaterThan1m+ '%'}"></div>
							</div>
							<div class="percent">{{response.firstResponse.firstResponseGreaterThan1m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">45s-1m</div>
							<div class="progress">
								<div class="p2" :style="{width:response.firstResponse.firstResponse45sAnd1m+ '%'}"></div>
							</div>
							<div class="percent">{{response.firstResponse.firstResponse45sAnd1m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">30s-45s</div>
							<div class="progress">
								<div class="p3" :style="{width:response.firstResponse.firstResponse30sAnd45s+ '%'}"></div>
							</div>
							<div class="percent">{{response.firstResponse.firstResponse30sAnd45s}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">15s-30s</div>
							<div class="progress">
								<div class="p4" :style="{width:response.firstResponse.firstResponse15sAnd30s+ '%'}"></div>
							</div>
							<div class="percent">{{response.firstResponse.firstResponse15sAnd30s}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">15s</div>
							<div class="progress">
								<div class="p5" :style="{width:response.firstResponse.firstResponse15s+ '%'}"></div>
							</div>
							<div class="percent">{{response.firstResponse.firstResponse15s}}%</div>
						</div>
					</div>
				</div>
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">响应时间</span>
						</div>
					</div>
					<div class="main-4" style="height:300px;" v-loading="userResponseLoading">
						<div class="m-bar">
							<div class="m-bar-title">>1m</div>
							<div class="progress">
								<div class="p1" :style="{width:response.userResponse.responseGreaterThan1m+ '%'}"></div>
							</div>
							<div class="percent">{{response.userResponse.responseGreaterThan1m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">45s-1m</div>
							<div class="progress">
								<div class="p2" :style="{width:response.userResponse.response45sAnd1m+ '%'}"></div>
							</div>
							<div class="percent">{{response.userResponse.response45sAnd1m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">30s-45s</div>
							<div class="progress">
								<div class="p3" :style="{width:response.userResponse.response30sAnd45s+ '%'}"></div>
							</div>
							<div class="percent">{{response.userResponse.response30sAnd45s}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">15s-30s</div>
							<div class="progress">
								<div class="p4" :style="{width:response.userResponse.response15sAnd30s+ '%'}"></div>
							</div>
							<div class="percent">{{response.userResponse.response15sAnd30s}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">15s</div>
							<div class="progress">
								<div class="p5" :style="{width:response.userResponse.response15s+ '%'}"></div>
							</div>
							<div class="percent">{{response.userResponse.response15s}}%</div>
						</div>
					</div>
				</div>
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">会话时长</span>
						</div>
					</div>
					<div class="main-5" style="height:300px;" v-loading="userResponseLoading">
						<div class="m-bar">
							<div class="m-bar-title">>8m</div>
							<div class="progress">
								<div class="p1" :style="{width:response.duration.durationGreaterThan8m+ '%'}"></div>
							</div>
							<div class="percent">{{response.duration.durationGreaterThan8m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">6m-8m</div>
							<div class="progress">
								<div class="p2" :style="{width:response.duration.duration6mAnd8m+ '%'}"></div>
							</div>
							<div class="percent">{{response.duration.duration6mAnd8m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">4m-6m</div>
							<div class="progress">
								<div class="p3" :style="{width:response.duration.duration4mAnd6m+ '%'}"></div>
							</div>
							<div class="percent">{{response.duration.duration4mAnd6m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title">2m-4m</div>
							<div class="progress">
								<div class="p4" :style="{width:response.duration.duration2mAnd4m+ '%'}"></div>
							</div>
							<div class="percent">{{response.duration.duration2mAnd4m}}%</div>
						</div>
						<div class="m-bar">
							<div class="m-bar-title"><2m</div>
							<div class="progress">
								<div class="p5" :style="{width:response.duration.duration2m+ '%'}"></div>
							</div>
							<div class="percent">{{response.duration.duration2m}}%</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex-box">
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">问题解决率</span>
							<!-- <el-select v-model="value" placeholder="客服解决状态" style="float: right;">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>-->
						</div>
					</div>
					<div id="main-3" style="height:300px;"></div>
				</div>
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">满意度</span>
						</div>
					</div>
					<div id="main-4" style="height:300px;"></div>
				</div>
			</div>
			<div class="table_box">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">考勤信息</span>
					</div>
				</div>
				<el-table :data="tableData" style="width: 100%;overflow-x: auto;">
					<el-table-column prop="time" label="日期" widh="150"></el-table-column>
					<el-table-column prop="loginTime" label="登录时长">
						<template slot-scope="scope">{{secondToDate(scope.row.loginTime)}}</template>
					</el-table-column>
					<el-table-column prop="moveInTime" label="就绪时长" widh="180">
						>
						<template slot-scope="scope">{{secondToDate(scope.row.moveInTime)}}</template>
					</el-table-column>
					<el-table-column prop="moveOutTime" label="迁出时长" widh="180">
						>
						<template slot-scope="scope">{{secondToDate(scope.row.moveOutTime)}}</template>
					</el-table-column>
					<el-table-column prop="restTime" label="小休时长" widh="180">
						>
						<template slot-scope="scope">{{secondToDate(scope.row.restTime)}}</template>
					</el-table-column>
					<el-table-column prop="cultivate" label="培训时长" widh="180">
						>
						<template slot-scope="scope">{{secondToDate(scope.row.cultivate)}}</template>
					</el-table-column>
					<el-table-column prop="haveMeals" label="用餐时长" widh="180">
						>
						<template slot-scope="scope">{{secondToDate(scope.row.haveMeals)}}</template>
					</el-table-column>
					<el-table-column prop="moveInTimeRatio" label="就绪占比" widh="180">
						>
						<template slot-scope="scope">{{getRatio(scope.row.moveInTimeRatio)}}</template>
					</el-table-column>
					<el-table-column prop="moveOutTimeRatio" label="未就绪占比" widh="180">
						>
						<template slot-scope="scope">{{getRatio(scope.row.moveOutTimeRatio)}}</template>
					</el-table-column>
					<el-table-column prop="restTimeRatio" label="小休占比" widh="180">
						>
						<template slot-scope="scope">{{getRatio(scope.row.restTimeRatio)}}</template>
					</el-table-column>
					<el-table-column prop="cultivateRatio" label="培训占比" widh="180">
						>
						<template slot-scope="scope">{{getRatio(scope.row.cultivateRatio)}}</template>
					</el-table-column>
					<el-table-column prop="haveMealsRatio" label="用餐占比" widh="180">
						>
						<template slot-scope="scope">{{getRatio(scope.row.haveMealsRatio)}}</template>
					</el-table-column>
					<el-table-column prop="firstOnlineTime" label="首次在线时间" widh="230">
						>
						<template slot-scope="scope">{{getFormat(scope.row.firstOnlineTime)}}</template>
					</el-table-column>
					<el-table-column prop="logoutTime" label="登出时长" widh="180">
						>
						<template slot-scope="scope">{{getFormat(scope.row.logoutTime)}}</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination :page-size="100" background layout="total, prev, pager, next" :total="2"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
let echarts = require('echarts')
import { DateTime } from '@/utils/common'
import { FormatTimes, formatDuring } from '@/utils/FormatTime'
import { Base64 } from 'js-base64'
export default {
	name: 'report1',
	props: [],
	data() {
		return {
			value1: '',
			options: [
				{
					value: '选项1',
					label: '客服解决状态'
				},
				{
					value: '选项2',
					label: '用户解决状态'
				}
			],
			tableData: [],
			pickerVal: [],
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			userHead: {
				userAccessInfo: {
					accessCount: 0, //接入会话量
					replyReteCount: 0, //回复率
					transferCount: 0 //转接量
				},
				userMessageInfo: {
					allMessageCount: 0,
					qOrARatio: 0,
					responseRate: 0
				},
				userConversationTime: {
					aveContionSecond: 0,
					firstAvgResponse: 0,
					avgResponseCount: 0
				},
				userLeavingaMessageHandle: {
					leavingaMessageCount: 0,
					processedCount: 0,
					resolutionRate: 0
				},
				userComment: {
					participationRate: 0,
					oneTimeResolutionRate: 0,
					satisfactionRate: 0
				}
			},
			userHeadLoding: false,
			userCenterAccessLoding: false, //已接入会话量
			userCenterMessageLoding: false, //消息量
			userResponseLoading: false, //响应时间
			response: {
				userResponse: {
					response15s: 10,
					response15sAnd30s: 0,
					response30sAnd45s: 0,
					response45sAnd1m: 0,
					responseGreaterThan1m: 0
				},
				firstResponse: {
					firstResponse15s: 0,
					firstResponse15sAnd30s: 0,
					firstResponse30sAnd45s: 0,
					firstResponse45sAnd1m: 0,
					firstResponseGreaterThan1m: 0
				},
				duration: {
					duration2m: 0,
					duration2mAnd4m: 0,
					duration4mAnd6m: 0,
					duration6mAnd8m: 0,
					durationGreaterThan8m: 0
				}
			},
			exportUserLoading: false
		}
	},
	watch: {
		pickerVal: function(val) {
			this.getUserHeadReport('工作报表-搜索')
			this.getUserCenterAccountReport()
			this.getUserCenterMessageReport()
			this.getUserCenterResponse()
			this.getUserProbleSolvingRate()
			this.getUserLoginLog()
		}
	},
	mounted: function() {
		let datetime = new DateTime()
		this.pickerVal.push(FormatTimes(datetime.Now(), 'yyyy-MM-dd'))
		this.pickerVal.push(FormatTimes(datetime.Now(), 'yyyy-MM-dd'))
		this.getUserHeadReport("工作报表-页面初始化")
		this.getUserCenterAccountReport()
		this.getUserCenterMessageReport()
		this.drawChart()
		this.getUserProbleSolvingRate()
		this.getUserLoginLog()
	},
	methods: {
		drawChart() {
			// 基于准备好的dom，初始化echarts实例
		},
		getUserHeadReport(auditChannel) {
			let vm = this
			vm.userHeadLoding = true
			vm.axios
				.post('UserReportForm/GetUserHeadReport', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				},{Headers:{auditChannel:Base64.encode(auditChannel)}})
				.then(function({ data }) {
					if (data.result) {
						console.log(data.data)
						vm.userHead = data.data
					}
					vm.userHeadLoding = false
				})
		},
		getUserCenterAccountReport() {
			let myChart1 = this.$echarts.init(document.getElementById('main-1'))
			let vm = this
			vm.userCenterAccessLoding = true
			vm.axios
				.post('UserReportForm/GetUserCenterAccountReport', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				})
				.then(function({ data }) {
					vm.userCenterAccessLoding = false
					if (data.result != true) {
						return
					}

					let xAxisData = data.data.recovered.list.map(d => d.time)
					// 指定图表的配置项和数据
					let option1 = {
						tooltip: {
							trigger: 'axis'
						},
						color: ['#0066ff', '#33cc33', '#808bc6'],
						legend: {
							data: [
								'已回复会话量',
								'未回复会话量',
								'已接入会话量'
							],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom'
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled']
								},
								restore: { show: true },
								saveAsImage: { show: true }
							}
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: xAxisData
							}
						],
						yAxis: [
							{
								type: 'value'
							}
						],
						series: [
							{
								name: data.data.recovered.name,
								type: 'line',
								stack: '总量',
								data: data.data.recovered.list.map(d => d.count)
							},
							{
								name: data.data.unanswered.name,
								type: 'line',
								stack: '总量',
								data: data.data.unanswered.list.map(
									d => d.count
								)
							},
							{
								name: data.data.connectedSession.name,
								type: 'line',
								stack: '总量',
								data: data.data.connectedSession.list.map(
									d => d.count
								)
							}
						]
					}
					myChart1.setOption(option1)
				})
		},
		getUserCenterMessageReport() {
			let vm = this
			let myChart2 = this.$echarts.init(document.getElementById('main-2'))
			vm.userCenterMessageLoding = true
			vm.axios
				.post('UserReportForm/GetUserCenterMessageReport', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				})
				.then(function({ data }) {
					vm.userCenterMessageLoding = false
					if (!data.result) {
						return
					}
					let xAxisData = data.data.connectedSession.list.map(
						d => d.time
					)
					let option2 = {
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							data: [
								'访客发出消息',
								'客服发出消息',
								'已接入会话量'
							],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom'
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled']
								},
								restore: { show: true },
								saveAsImage: { show: true }
							}
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: xAxisData
							}
						],
						yAxis: [
							{
								type: 'value'
							}
						],
						series: [
							{
								name: data.data.customerService.name,
								type: 'line',
								stack: '总量',
								data: data.data.customerService.list.map(
									d => d.count
								)
							},
							{
								name: data.data.visitor.name,
								type: 'line',
								stack: '总量',
								data: data.data.visitor.list.map(d => d.count)
							},
							{
								name: data.data.connectedSession.name,
								type: 'line',
								stack: '总量',
								data: data.data.connectedSession.list.map(
									d => d.count
								)
							}
						]
					}
					myChart2.setOption(option2)
				})
		},
		getUserCenterResponse() {
			let vm = this
			vm.userResponseLoading = true
			this.axios
				.post('UserReportForm/GetUserCenterResponse', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				})
				.then(function({ data }) {
					if (data.result) {
						vm.response = data.data
					}
					vm.userResponseLoading = false
				})
		},
		getUserProbleSolvingRate() {
			let vm = this
			let myChart3 = this.$echarts.init(document.getElementById('main-3'))
			let myChart4 = this.$echarts.init(document.getElementById('main-4'))

			this.axios
				.post('UserReportForm/GetUserProbleSolvingRate', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				})
				.then(function({ data }) {
					if (data.result) {
						// let myChart2 = this.$echarts.init(document.getElementById('main-2'))
						let commentName = data.data.degree.map(
							d => d.commentName
						)
						let commentArr = []

						data.data.degree.forEach(element => {
							var obj = new Object()
							obj.value = element.count
							obj.name = element.commentName
							commentArr.push(obj)
						})
						let option3 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500
								}
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: [
									`未标记`,
									'未解决',
									'已解决',
									'无效会话'
								],
								fontSize: 12
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)'
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)'
							},
							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: [
										{
											value: data.data.solvingRate.unmark,
											name: '未标记',
											id: -1
										},
										{
											value:
												data.data.solvingRate.unsolved,
											name: '未解决',
											id: 0
										},
										{
											value:
												data.data.solvingRate.resolved,
											name: '已解决',
											id: 1
										},
										{
											value:
												data.data.solvingRate
													.invalidSession,
											name: '无效会话',
											id: 2
										}
									],
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489'
									]
								}
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)'
									},
									labelLine: {
										show: true
									}
								}
							}
						}

						let option4 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500
								}
							},
							type: 'pie',
							label: {
								show: true,
								formatter: '{b} ({d}%)'
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)'
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: commentName,
								fontSize: 12

								/* itemWidth:10,
                itemHeight:10*/
							},

							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: commentArr,
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489'
									]
								}
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)'
									},
									labelLine: {
										show: true
									}
								}
							}
						}
						myChart3.setOption(option3)
						myChart4.setOption(option4)
					}
				})
		},
		getUserLoginLog() {
			let vm = this
			this.axios
				.post('UserReportForm/GetUserLoginReports', {
					StartTime: vm.pickerVal[0],
					EndTime: vm.pickerVal[1]
				})
				.then(function({ data }) {
					if (data.result) {
						vm.tableData = data.data
						console.log(vm.tableData)
					}
				})
		},
		convertMin(ss) {
			//转换
			let dateTime = new DateTime()
			return dateTime.convertSSAndMin(ss)
		},
		getFormat(time) {
			if (time == undefined || time == null) {
				return '--'
			}
			return FormatTimes(time, 'hh:mm:ss')
		},
		getRatio(val) {
			if (val == undefined || val == null || val == 0) {
				return '--'
			} else {
				return val + '%'
			}
		},
		secondToDate: function(msd) {
			if (msd == null || msd == undefined || msd == 0) {
				return '--'
			}

			return formatDuring(msd)
		},
		exportUser() {
			let vm = this
			vm.exportUserLoading = true
			let obj = localStorage.getItem(vm.LoginInfo)
			let userObj = JSON.parse(obj)
			this.axios
				.post(
					'UserReportForm/ExportUser',
					{
						StartTime: vm.pickerVal[0],
						EndTime: vm.pickerVal[1]
					},
					{
						responseType: 'blob'
					}
				)
				.then(function(res) {
					let filename = `客服：${userObj.nickName}，时间范围:${vm.pickerVal[0]}~${vm.pickerVal[1]}.xls`
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						vm.exportUserLoading = false
						vm.$message({ type: 'success', message: '导出成功' })
					}
				})
		}
	}
}
</script>

<style scoped>
.container {
	padding: 0px 45px;
	height: 100%;
}
.flex {
	padding: 30px 0 10px 0;
}
.title {
	font-size: 16px;
	font-weight: bold;
	float: left;
}
.dropmenu button {
	border-radius: 4px 0 0 4px !important;
	border-right: none;
}
.date_box {
	float: right;
	margin-right: 20px;
}
.date {
	width: 140px;
}
.export {
	float: right;
}
.flex-box {
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
}
.flex-box .m-ValueBox {
	flex: 1;
	border: 1px solid #ddd;
	margin-left: 20px;
	text-align: center;
}
.m-ValueBox-top {
	padding-top: 18px;
	padding-bottom: 15px;
	background-color: #fff;
}
.m-ValueBox-top > div:nth-child(2) {
	font-size: 30px;
	min-height: 45px;
	color: #337eff;
	margin-top: 10px;
	white-space: nowrap;
	text-align: center;
}
.m-ValueBox-bottom {
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	justify-content: space-around;
	height: 90px;
	border-top: 1px solid #ddd;
}
.m-echart {
	margin-top: 20px;
}
.m-echart-titleTxt {
	font-size: 16px;
}
.m-echart-title {
	margin-bottom: 30px;
}
.flex-box > div {
	flex: 1;
	margin-right: 30px;
}
.m-bar {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: flex-start;
	line-height: 40px;
}
.m-bar .m-bar-title {
	width: 15%;
}
.m-bar .percent {
	width: 5%;
	text-align: right;
}
.m-bar .progress {
	height: 15px;
	width: 80%;
}
.m-bar .progress > div {
	height: 15px;
	width: 0;
	transition: width 2s;
	-webkit-transition: width 2s;
}
.m-bar .progress .p1 {
	background-color: #3a8ee6;
}
.m-bar .progress .p2 {
	background-color: #e6a23c;
}
.m-bar .progress .p3 {
	background-color: #df5000;
}
.m-bar .progress .p4 {
	background-color: #5abc5c;
}
.m-bar .progress .p5 {
	background-color: #795da3;
}
#main-3 {
	border: 1px solid #ddd;
}
#main-4 {
	border: 1px solid #ddd;
}

.el-button.export {
	background-color: #409eff;
	color: #fff;
}
.table_box {
	margin-top: 40px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
.el-button {
	background-color: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/report/report1.vue